import { isMobile } from "react-device-detect";
import tinycolor from "tinycolor2";

const primary = "#FFFFFF";
const secondary = "#1641DB";
const warning = "#FFC260";
const success = "#3CD4A0";
const info = "#9013FE";

const lightenRate = 7.5;
const darkenRate = 15;

export default {
  palette: {
    primary: {
      main: primary,
      contrastText: "#F30020",
      light: tinycolor(primary).lighten(lightenRate).toHexString(),
      dark: tinycolor(primary).darken(darkenRate).toHexString(),
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary).lighten(lightenRate).toHexString(),
      dark: tinycolor(secondary).darken(darkenRate).toHexString(),
      contrastText: "#FFFFFF",
    },
    warning: {
      main: warning,
      light: tinycolor(warning).lighten(lightenRate).toHexString(),
      dark: tinycolor(warning).darken(darkenRate).toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success).lighten(lightenRate).toHexString(),
      dark: tinycolor(success).darken(darkenRate).toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info).lighten(lightenRate).toHexString(),
      dark: tinycolor(info).darken(darkenRate).toHexString(),
    },
    text: {
      primary: "#1A1A1A",
      secondary: "#666666",
      hint: "#B9B9B9",
    },
    background: {
      default: isMobile ? "#FFFFFF" : "#F9F9F9",
      light: "#F3F5FF",
    },
    action: {
      disabledBackground: "rgba(238,238,238,0.18)",
      disabled: "#999999",
    },
  },
  customShadows: {
    widget:
      "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
    widgetDark:
      "0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
    widgetWide:
      "0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
  },
  overrides: {
    MuiOutlinedInput: {
      input: {
        padding: "8px 8px",
      },
    },
    MuiButton: {
      root: {
        padding: "8px 12px",
        outline: "none",
        textTransform: "none",
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "#4A4A4A1A",
      },
    },
    MuiMenu: {
      paper: {
        boxShadow:
          "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
      },
    },
    MuiSelect: {
      icon: {
        color: "#B9B9B9",
      },
    },
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "#F3F5FF !important",
          "&:focus": {
            backgroundColor: "#F3F5FF",
          },
        },
      },
      button: {
        "&:hover, &:focus": {
          backgroundColor: "#F3F5FF",
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: "white",
      },
    },
    MuiTableRow: {
      root: {
        height: 56,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "1px solid rgba(224, 224, 224, .5)",
        fontSize: "12px",
        lineHeight: "16px",
        color: "#1A1A1A",
        textTransform: "capitalize",
      },
      head: {
        color: "#1F1F1F",
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 600,
      },
    },
    MuiFormControlLabel: {
      label: {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: "20px",
      },
      labelPlacementStart: {
        marginLeft: 0,
      },
    },
    body: {
      fontSize: "0.95rem",
    },
  },
};
